namespace Solovis.Reports {

        

    export class ReportDataLoaderClient implements Solovis.Portal.IReportDataLoader {

        private _portalServices: Solovis.Portal.IPortalServices;
        private _rpc: () => Solovis.RpcClients.IRpcClient;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices
        }) {
            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }

            if (this._portalServices) {
                this._rpc = () => this._portalServices.rpc();
            }
            else {
                this._rpc = () => Solovis.Rpc;
            }
        }

        /**
         * Attempt to load the report definition for a report. Callback should be a function (response, success)
         * like what comes back from Solovis.Rpc.invoke. The response.result will have a report property if the
         * request succeeds.
         * @param reportRef
         * @param callback
         */
        public getReportDefinitionAsync(reportRef, callback?): Promise<any> {
            var promise = new Promise((resolve, reject) => {

                var callbackWrapper = function (response, success) {
                    try {
                        if (callback) {
                            callback(response, success);
                        }
                    }
                    catch (ex) {
                        console.log(ex);
                    }

                    if (success) {
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                };

                var request: any = {};

                if (!reportRef) {
                    throw "reportRef not set";
                }
                else if (reportRef.code) {
                    request.reportCode = reportRef.code;
                }
                else if (reportRef.alias) {
                    request.reportAlias = reportRef.alias;
                }
                else if (reportRef.path) {
                    request.reportPath = reportRef.path;
                }
                else {
                    throw "reportRef does not specify a reference to a report";
                }

                var getReportDefinitionResponseFromResponseResult = function (result) {
                    try {
                        var reportDefinitionScript = result.reportDefinitionScript;

                        var reportDefinitionLoadScript =
                            "(function () {\r\n"
                            + reportDefinitionScript
                            + "\r\n return report;"
                            + "\r\n})()";

                        var reportDefinition = eval(reportDefinitionLoadScript);

                        reportResponse = {
                            result: {
                                report: reportDefinition,
                                name: result.name,
                                code: result.code,
                                path: result.path,
                                resourceId: result.resourceId
                            }
                        };

                        return reportResponse;
                    }
                    catch (ex) {
                        var errorResponse = {
                            error: { jsException: ex }
                        };

                        return errorResponse;
                    }
                };

                var cachedReportDef = Solovis.Reports.ReportDefinitionCache.tryGetCachedReportDefinition(reportRef, this._portalServices);
                if (cachedReportDef) {
                    var reportResponse = getReportDefinitionResponseFromResponseResult(cachedReportDef);
                    var success = reportResponse.error ? false : true;
                    callbackWrapper(reportResponse, success);
                }
                else {
                    this._rpc().invoke("~/ReportData/GetReportDefinition", request,
                        (response, success) => {
                            if (success) {
                                var reportResponse = getReportDefinitionResponseFromResponseResult(response.result);
                                var reportSuccess = reportResponse.error ? false : true;

                                if (reportSuccess) {
                                    Solovis.Reports.ReportDefinitionCache.tryToCacheReportDefinition(reportRef, response.result, this._portalServices);
                                }

                                callbackWrapper(reportResponse, reportSuccess);
                            }
                            else {
                                callbackWrapper(response, success);
                            }
                        });
                }
            });

            return promise;
        }


        /**
         * Attempt to load the data set. Callback should be a function (response, success)
         * like what comes back from Solovis.Rpc.invoke. The response.result will have a dataSet property if the
         * request succeeds.
         * @param dataSourcePathOrCodeSpecification
         * @param options
         * @param callback
         * @param invokeOptions
         * @param extraData
         */
        public loadDataSetAsync(
            dataSourcePathOrCodeSpecification,
            options,
            callback?,
            invokeOptions?,
            extraData?
        ): Promise<any> {

            let promise = new Promise((resolve, reject) => {

                let rpc = this._rpc();

                var callbackWrapper = function (response, success) {
                    try {
                        if (callback) {
                            callback(response, success);
                        }
                    }
                    catch (ex) {
                        console.log(ex);
                    }

                    if (success) {
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                };

                let dataSourceCode = null;
                let dataSourcePath = null;
                if (typeof dataSourcePathOrCodeSpecification == "string") {
                    dataSourcePath = dataSourcePathOrCodeSpecification;
                }
                else if (typeof dataSourcePathOrCodeSpecification == "object") {
                    dataSourcePath = dataSourcePathOrCodeSpecification.path ? dataSourcePathOrCodeSpecification.path : null;
                    dataSourceCode = dataSourcePathOrCodeSpecification.code ? dataSourcePathOrCodeSpecification.code : null;
                }
                else {
                    throw "Unexpected value for dataSourcePathOrCodeSpecification";
                }

                let canBatch = true;
                if (invokeOptions && invokeOptions.noBatch) {
                    canBatch = false;
                }
                if (this._portalServices && this._portalServices.isProxiedDataEnvironment()) {
                    // Disable batching on proxied data environments (BatchDataSetLoader doesn't currently support multiple proxied data environments).
                    canBatch = false;
                }

                let invokeMethod = rpc.invoke;
                if (invokeOptions) {
                    if (invokeOptions.invokeMethod == "invokeAndWait") {
                        canBatch = false;
                        invokeMethod = rpc.invokeAndWait;
                    }
                    if (invokeOptions.forceNoReadOnly) {

                    }
                }

                let reportCode = null;
                let cachingOptions = null;
                let dataContext = null;
                if (extraData) {
                    if (extraData.reportCode) {
                        reportCode = extraData.reportCode;
                    }
                    if (extraData.cachingOptions) {
                        cachingOptions = extraData.cachingOptions;
                    }
                    if (extraData.dataContext) {
                        dataContext = extraData.dataContext;
                    }
                }

                let pendingRequest: any = {
                    path: dataSourcePath,
                    code: dataSourceCode,
                    options: options,
                    reportCode: reportCode
                };

                if (cachingOptions) {
                    pendingRequest.caching = cachingOptions;
                }
                if (dataContext) {
                    pendingRequest.dataContext = dataContext;
                }
                if (invokeOptions && invokeOptions.forceNoReadOnly) {
                    pendingRequest.xhrRequestOptions = {
                        forceNoReadOnly: true
                    };
                }

                if (!canBatch) {
                    invokeMethod.call(
                        rpc,
                        "~/Rpc/DataSource/LoadDataSet",
                        pendingRequest,
                        function (response, success) {
                            callbackWrapper(response, success);
                        });
                }
                else {
                    pendingRequest.callback = callbackWrapper;
                    pendingRequest.requestId = _.uniqueId("_loadDataSet_");
                    pendingRequest.requestedAtTime = (new Date().getTime());

                    Solovis.Reports.BatchDataSetLoader.submitBatchDataSetRequest(pendingRequest);
                }
            });

            return promise;
        }

    }


    export const ReportDataLoader: ReportDataLoaderClient = new ReportDataLoaderClient();
       
}

    
